import { render, staticRenderFns } from "./SettingDialog.vue?vue&type=template&id=6ca95804"
import script from "./SettingDialog.vue?vue&type=script&lang=js"
export * from "./SettingDialog.vue?vue&type=script&lang=js"
import style0 from "./SettingDialog.vue?vue&type=style&index=0&id=6ca95804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports